
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import ROUTES from '@/routes-map';

const AIAssistantPage: React.FC = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    toast({
      title: "Submitted!",
      description: "Your query has been submitted to the AI Assistant.",
    });
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">AI Assistant</h1>
      <p className="mb-4">
        Get quick answers and suggestions for patient care, treatment plans, and more.
      </p>

      <Card className="shadow-md">
        <CardContent className="p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="patientName">Patient Name</Label>
              <Input type="text" id="patientName" placeholder="Enter patient name" />
            </div>
            <div>
              <Label htmlFor="queryType">Type of Query</Label>
              <select id="queryType" className="w-full p-2 border rounded">
                <option>Treatment Plan</option>
                <option>Diagnosis Assistance</option>
                <option>Medication Information</option>
                <option>Other</option>
              </select>
            </div>
            <div>
              <Label htmlFor="details">Details</Label>
              <Textarea id="details" placeholder="Enter details of your query" className="min-h-[100px]" />
            </div>
            <div className="flex justify-end gap-2">
              <Button variant="outline" size="sm" onClick={() => navigate(ROUTES.DOCTOR.DASHBOARD)}>
                Cancel
              </Button>
              <Button variant="default" size="sm" onClick={() => navigate(ROUTES.DOCTOR.TREATMENT_PLANS)}>
                Submit
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AIAssistantPage;
